import apiFetch from '../../../utils/apiFetch';

export const applyPushOnHit = async (campaignId, payload) => {
  if (!campaignId) return { status: 'inactive-combat' };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/push/apply`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok && !result.status) throw new Error(response.statusText || 'Push movement could not be applied.');
  return result;
};
